import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const warmExchangeAgentCaches = {
  name: "warmExchangeAgentCaches" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    returnType: createEnum(ReturnTypeEnum).optional(),
  }),
  output: z.void(),
};
